
$(function() {
    /**
     * Form loading support
     */
    $(document).on('submit', 'form', function (event) {
        const form = $(event.currentTarget);

        form.formLoading();

        // Ajax Modal
        form.closest('.modal').one('form-complete.modal', function () {
            form.formLoading()
        })
    });

    $.fn.formLoading = function () {
        $.each(this, function (index, element) {
            const form = $(element),
                btn = form.find('input[type=submit], button[type=submit], a.btn');

            btn.toggleClass('disabled')
        })
    };
});


// WEBPACK FOOTER //
// ./js/form/loading.js